import React, { useEffect, useState } from 'react';
import { cases as casesApi } from '../utils/api';
import letterhead from '../assets/letterhead-a5.png';
import signature from '../assets/signature.png';
import { formatDate } from '../utils/format';

/**
 * برگه‌ی A5 گزارش — همان چیزی که روی کاغذ خام چاپ می‌شود.
 *
 * سربرگ یک **تصویر** است، نه رنگِ پس‌زمینه در CSS: مرورگر به‌صورت پیش‌فرض
 * پس‌زمینه‌ها را چاپ نمی‌کند (تیکِ «Background graphics») ولی <img> را همیشه
 * چاپ می‌کند. با این کار کاربر یک تیک کمتر برای زدن دارد.
 *
 * طرح ۵ میلی‌متر به داخل کشیده شده چون هیچ پرینتر اداری‌ای تا لبه‌ی کاغذ
 * چاپ نمی‌کند؛ این‌طور حاشیه‌ی سفید عمدی به نظر می‌رسد نه بریدگی.
 */

const CLOSING = 'Respectfully & kind regards';
const SIGNER = 'Dr. Ali Salehi';
const QR_CAPTION = 'Scan for Digital files and videos';

export default function ReportSheet({ item, text, template }) {
  const qrSrc = useQrImage(item.id, Boolean(item.patient_link));

  return (
    <div className="a5" role="document" aria-label="برگه‌ی گزارش">
      <img className="a5__letterhead" src={letterhead} alt="" aria-hidden="true" />

      <div className="a5__content">
        <dl className="a5__patient">
          <div>
            <dt>Patient</dt>
            <dd><bdi>{item.name}</bdi></dd>
          </div>
          <div>
            <dt>Referred by</dt>
            <dd><bdi>{item.doctor}</bdi></dd>
          </div>
          <div>
            <dt>No.</dt>
            <dd>{item.order_number}</dd>
          </div>
          <div>
            <dt>Date</dt>
            <dd>{formatDate(item.reception_time)}</dd>
          </div>
        </dl>

        <pre className="a5__body" dir={(template && template.direction) || 'ltr'}>
          {text}
        </pre>

        <footer className="a5__foot">
          <div className="a5__sign">
            <span>{CLOSING}</span>
            <img src={signature} alt="" aria-hidden="true" />
            <strong>{SIGNER}</strong>
          </div>

          {qrSrc && (
            <div className="a5__qr">
              <img src={qrSrc} alt="QR لینک تصاویر بیمار" />
              <span>{QR_CAPTION}</span>
            </div>
          )}
        </footer>
      </div>
    </div>
  );
}

/**
 * QR توکن می‌خواهد، پس <img src> مستقیم کار نمی‌کند و باید blob گرفت.
 * پرونده‌ی بدون لینک اصلاً درخواست نمی‌فرستد.
 */
function useQrImage(caseId, enabled) {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    if (!enabled) {
      setSrc(null);
      return undefined;
    }

    let url = null;
    let alive = true;

    casesApi
      .patientQr(caseId)
      .then(({ data }) => {
        if (!alive) return;
        url = window.URL.createObjectURL(data);
        setSrc(url);
      })
      .catch(() => {
        if (alive) setSrc(null);
      });

    return () => {
      alive = false;
      if (url) window.URL.revokeObjectURL(url);
    };
  }, [caseId, enabled]);

  return src;
}
